import React, { useState } from 'react';
import { RadioButton, RadioButtonGroup } from '@sabre/spark-react-core';
import { map, isFunction } from 'lodash';
import { shape, string, arrayOf, bool, func } from 'prop-types';

const RadioButtons = ({
   radioButtonsConfig: {
      disabled,
      onChangeHandler,
      radioButtonClassName,
      radioButtonGroupClassName,
      radioButtonName,
      radioButtons,
      title,
      titleClassName,
      value,
   },
}) => {
   const [selectedValue, setSelectedValue] = useState(value);

   const onGroupChange = (event, radioButtonValue) => {
      setSelectedValue(radioButtonValue);
      if (isFunction(onChangeHandler)) {
         onChangeHandler(event, radioButtonValue);
      }
   };

   return (
      <RadioButtonGroup
         key={radioButtonName}
         name={radioButtonName}
         className={`row radio-buttons-container ${
            radioButtonGroupClassName || ''
         }`}
         value={value}
         onChange={onGroupChange}
      >
         {title && <div className={titleClassName}>{title}:</div>}
         {map(radioButtons, ({ label, value }) => (
            <RadioButton
               key={`${radioButtonName}-${value}`}
               label={label}
               value={value}
               className={`radio-button ${radioButtonClassName || ''}`}
               disabled={disabled}
               checked={value === selectedValue}
            />
         ))}
      </RadioButtonGroup>
   );
};

RadioButtons.propTypes = {
   radioButtonsConfig: shape({
      radioButtonName: string.isRequired,
      radioButtonGroupClassName: string,
      radioButtons: arrayOf(
         shape({
            label: string.isRequired,
            value: string.isRequired,
         })
      ).isRequired,
      radioButtonClassName: string,
      title: string,
      titleClassName: string,
      disabled: bool,
      onChangeHandler: func,
      value: string,
   }).isRequired,
};

export default RadioButtons;
